import Nav from "components/Nav";
import IEDeprecationBanner from "components/IEDeprecationBanner";
import BreakingNewsBar from "components/BreakingNewsBar";
import lazy from "utils/lazy";

const BottomLeaflets = lazy(() => import("components/BottomLeaflets"));
const Footer = lazy(() => import("components/Footer"));

const PageLayout = ({
  children,
  analyticsCategory,
  sonsPromo,
}: {
  children: React.ReactNode;
  analyticsCategory?: string;
  sonsPromo?: React.ReactNode;
}) => {
  return (
    <>
      <Nav />
      <IEDeprecationBanner />
      <BreakingNewsBar analyticsCategory={analyticsCategory} />
      {children}
      {sonsPromo && sonsPromo}
      {!sonsPromo && <BottomLeaflets analyticsCategory={analyticsCategory} />}
      <Footer analyticsCategory={analyticsCategory} />
    </>
  );
};

export default PageLayout;
